module.exports = __webpack_public_path__ + "img/bale_icon.2c6c40b9.png";